import { Serializer } from "survey-core";

export function registerChoiceItemProperties() {
  if (Serializer.findProperty("question", "icon")) {
    Serializer.removeProperty("question", "icon");
  }

  if (Serializer.findProperty("itemvalue", "icon")) {
    return;
  }

  Serializer.addProperty("itemvalue", {
    name: "icon",
    displayName: "Icon URL",
    type: "string",
    category: "choices",
    categoryIndex: 1,
    locationInTable: "detail",
    default: "",
  });
}
